import { render, staticRenderFns } from "./veStuChangeEdit.vue?vue&type=template&id=c0df7f4a&scoped=true"
import script from "./veStuChangeEdit.vue?vue&type=script&lang=js"
export * from "./veStuChangeEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0df7f4a",
  null
  
)

export default component.exports